import { render, staticRenderFns } from "./InstagramPostGrid.vue?vue&type=template&id=4a6e99cc"
import script from "./InstagramPostGrid.vue?vue&type=script&lang=ts"
export * from "./InstagramPostGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports